import { NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  standalone:true,
  imports: [ 
    FormsModule,
    NgStyle
  ]
})
export class CountdownComponent  implements OnInit {
 @Input() duration: number = 15;
 @Input() count: number = 15;
  ticks = Array.from({ length: 60 });
  constructor() { }

  ngOnInit() {}

}
